export enum Discipline {
  PhysicalTherapy = "PT",
  OccupationalTherapy = "OT",
  SpeechTherapy = "ST",
}

export enum AllDisciplines {
  PT = 1,
  OT = 2,
  ST = 3,
  PTA = 4,
  COTA = 5,
  STA = 6,
  CFY = 7
}

export enum DisciplineNumber {
  PT = 1,
  OT = 2,
  ST = 3,
}

export const DisciplineRelation: { [key: number]: number } = {
  4: 1,
  5: 2,
  6: 3,
  7: 3,
};

export enum DocumentTypes{
  EPOC = 1,
  ProgressReport = 2,
  DCProgressReport = 3,
  ReEvaluationAndUpdatedPlanOfCare = 4,
  SupplementalEvaluationAndPlanOfCare = 5,
  RecertificationAndUpdatedPlanOfCare = 6,
  AddendumNote = 7,
  EPOCST = 8,
  ProgressReportST = 9,
  DCProgressReportST = 10,
  RecertificationAndUpdatedPlanOfCareST = 11
}

export enum DocumentCategory {
  EPOC = 1,
  PR = 2,
  DC = 3,
  RC = 4,
  InitiateEval = 99
}